// Страница верификации email: срабатывает по ссылке из письма.
// Автоматически вызывает API при монтировании и показывает результат.

import { useEffect, useState } from 'react';
import { Container, Card, Button, Spinner } from 'react-bootstrap';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { verifyEmail } from '../../api/authApi';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'

  useEffect(() => {
    if (!token) {
      setStatus('error');
      return;
    }

    verifyEmail(token)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className="ewl-auth-page">
      <Container>
        <div className="ewl-auth-card">
          {/* Логотип */}
          <div className="text-center mb-4">
            <div
              className="d-inline-flex align-items-center justify-content-center mb-3"
              style={{
                width: '3.5rem',
                height: '3.5rem',
                borderRadius: '1rem',
                background: 'linear-gradient(135deg, #4f6ef7 0%, #7c3aed 100%)',
                fontSize: '1.5rem',
                boxShadow: '0 4px 16px rgba(79,110,247,0.35)',
              }}
            >
              📖
            </div>
            <h4 className="fw-bold mb-1" style={{ letterSpacing: '-0.01em' }}>
              English We Love
            </h4>
            <p className="text-muted mb-0" style={{ fontSize: '0.875rem' }}>
              Подтверждение e-mail
            </p>
          </div>

          <Card
            className="border-0"
            style={{ borderRadius: '1rem', boxShadow: '0 4px 24px rgba(0,0,0,0.09)' }}
          >
            <Card.Body className="p-4 text-center">
              {status === 'loading' && (
                <>
                  <Spinner
                    animation="border"
                    variant="primary"
                    style={{ width: '2.5rem', height: '2.5rem', marginBottom: '1rem' }}
                  />
                  <p className="mb-0" style={{ fontSize: '0.9rem' }}>
                    Подтверждаем ваш e-mail...
                  </p>
                </>
              )}

              {status === 'success' && (
                <>
                  <div style={{ fontSize: '2.5rem', color: '#198754', marginBottom: '0.75rem' }}>
                    ✅
                  </div>
                  <h5 className="fw-bold mb-3">E-mail подтверждён!</h5>
                  <p className="mb-4" style={{ fontSize: '0.9rem' }}>
                    Регистрация завершена. Теперь вы можете войти в приложение.
                  </p>
                  <Button
                    size="lg"
                    className="w-100"
                    onClick={() => navigate('/login')}
                    style={{
                      background: 'linear-gradient(135deg, #4f6ef7 0%, #7c3aed 100%)',
                      border: 'none',
                      borderRadius: '0.6rem',
                      fontWeight: 600,
                      letterSpacing: '0.01em',
                    }}
                  >
                    Войти
                  </Button>
                </>
              )}

              {status === 'error' && (
                <>
                  <div style={{ fontSize: '2.5rem', color: '#dc3545', marginBottom: '0.75rem' }}>
                    ✖
                  </div>
                  <h5 className="fw-bold mb-3">Ссылка недействительна</h5>
                  <p className="mb-0" style={{ fontSize: '0.9rem' }}>
                    Ссылка для подтверждения устарела или уже была использована.
                  </p>
                </>
              )}
            </Card.Body>
          </Card>

          {status === 'error' && (
            <p className="text-center mt-3 text-muted" style={{ fontSize: '0.875rem' }}>
              <Link
                to="/login"
                style={{ color: 'var(--bs-primary)', fontWeight: 500, textDecoration: 'none' }}
              >
                Вернуться на главную
              </Link>
            </p>
          )}
        </div>
      </Container>
    </div>
  );
}
